import { pattern1 } from 'assets/images';
import React from 'react';

export const Title = ({ title, description }) => {
	return (
		<div className="rn-page-title-area pt--50 pb--50" style={{ backgroundImage: `url('${pattern1}')` }} data-black-overlay="6">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="rn-page-title text-center pt--100">
							<h2 className="title theme-gradient">{ title }</h2>
							{ description && <p>{ description }</p> }
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
